<ng-container *ngIf="producttype == 'Activity'">
    <app-booking-widget [lang]="lang" [external_channel]="external_channel" [api_url]="api_url" [web_city]="web_city"
        [channelactivitycode]="channelactivitycode" [productid]="productid" [producttype]="producttype"
        [PUBLIC_KEY]="public_key" [seller]="seller" [isOpenDate]="isOpenDate" [connector]="connector"
        [success_url]="success_url" [error_url]="error_url"></app-booking-widget>
    <div id="payment-element-parent" class="payment-container-parent">
        <div id="payment-element" class="payment-container">
        </div>
    </div>
</ng-container>
<ng-container *ngIf="producttype == 'Transfer'">
    <app-booking-widget-transfer [lang]="lang" [external_channel]="external_channel" [api_url]="api_url"
        [web_city]="web_city" [channelactivitycode]="channelactivitycode" [productid]="productid"
        [producttype]="producttype" [PUBLIC_KEY]="public_key" [seller]="seller" [isOpenDate]="isOpenDate"
        [connector]="connector"></app-booking-widget-transfer>
    <div id="payment-element-parent" class="payment-transfer-container-parent">
        <div id="payment-element" class="payment-transfer-container">
        </div>
    </div>
</ng-container>